import { useState } from 'react';
import { db, ref, get, update } from '../firebase';

const Login = ({ onLogin }) => {
  const [companyId, setCompanyId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const isFormValid = companyId.trim() !== '' && password.trim() !== '';

  const handleLogin = (e) => {
    e.preventDefault();
    if (!isFormValid) return;

    setIsLoading(true);
    setError('');

    const userRef = ref(db, `users/${companyId}`);
    get(userRef).then((snapshot) => {
      const user = snapshot.val();
      if (user && user.password === password) {
        const updatedUser = { ...user, lastLogin: Date.now() };
        update(userRef, { lastLogin: Date.now() });
        onLogin(updatedUser);
      } else {
        setError('Invalid Company ID or Password');
        setIsLoading(false);
      }
    });
  };

  return (
    <div className="flex h-screen justify-center items-center px-4 bg-slate-50 dark:bg-gray-900">
      <div className="bg-white dark:bg-gray-800 p-8 md:p-10 rounded-2xl shadow-2xl w-full max-w-md border border-gray-100 dark:border-gray-700 transition-all duration-300 transform hover:-translate-y-1">
        <div className="text-center mb-8">
          <img
            src="/img/logo.png"
            alt="Logo"
            className="w-20 h-20 object-contain mx-auto mb-4 rounded-xl shadow-sm bg-white p-1"
            onError={(e) => {
              e.target.style.display = 'none';
              document.getElementById('login-fallback-icon').style.display = 'flex';
            }}
          />
          <div id="login-fallback-icon" className="bg-blue-100 dark:bg-blue-900/50 w-16 h-16 rounded-full items-center justify-center mx-auto mb-4 text-blue-600 dark:text-blue-400 text-2xl" style={{ display: 'none' }}>
            <i className="fa-solid fa-box-archive"></i>
          </div>

          <h2 className="text-3xl font-extrabold text-gray-800 dark:text-white tracking-tight">AFGL Logistic Hub</h2>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-2 font-medium">Sign in to your account</p>
        </div>

        {error && (
          <div className="bg-red-50 dark:bg-red-900/30 border-l-4 border-red-500 text-red-700 dark:text-red-400 p-4 rounded mb-6 text-sm font-medium animate-fadein flex items-center">
            <i className="fa-solid fa-circle-exclamation mr-3 text-lg"></i>
            {error}
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Company ID</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                <i className="fa-solid fa-id-badge"></i>
              </div>
              <input
                type="number"
                disabled={isLoading}
                className="block w-full pl-10 pr-4 py-3 bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl focus:bg-white dark:focus:bg-gray-800 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all disabled:opacity-50 disabled:cursor-not-allowed outline-none text-base sm:text-sm"
                value={companyId}
                onChange={e => setCompanyId(e.target.value)}
                placeholder="Enter ID..."
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Password</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                <i className="fa-solid fa-lock"></i>
              </div>
              <input
                type="password"
                disabled={isLoading}
                className="block w-full pl-10 pr-4 py-3 bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl focus:bg-white dark:focus:bg-gray-800 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all disabled:opacity-50 disabled:cursor-not-allowed outline-none text-base sm:text-sm"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={!isFormValid || isLoading}
            className={`w-full flex justify-center items-center py-3.5 px-4 rounded-xl text-sm font-bold text-white transition-all duration-200 ${
              isFormValid && !isLoading
                ? 'bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 shadow-lg hover:shadow-blue-500/30 transform hover:-translate-y-0.5'
                : 'bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-500 cursor-not-allowed'
            }`}
          >
            {isLoading ? (
              <><i className="fa-solid fa-circle-notch fa-spin mr-2 text-lg"></i> Authenticating...</>
            ) : (
              <><i className="fa-solid fa-right-to-bracket mr-2 text-lg"></i> Sign In</>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
